
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/customer-stories/[customerStory]",
      function () {
        return require("private-next-pages/inspiration/customer-stories/[customerStory].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/customer-stories/[customerStory]"])
      });
    }
  